export default __webpack_public_path__ + "static/media/features.34693d38.png";